import React, { useState } from "react";
import { connect } from "react-redux";
import { createStore } from "devextreme-aspnet-data-nojquery";
import SubLotSearchFormResult from "../maintabs/sublot/SubLotSearchFormResult";
import SubLotSearchForm from "../maintabs/sublot/SubLotSearchForm";

const WMLotDetailsWithCustomer = (props) => {
    const orderStatus = "0";
    const getDataUrl = "wm/TransactionManagement/GetAllSubLots";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState("SubLots");
    const accessToken = props.oidc.user.access_token;

    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: "rowId",
            loadParams: {
                RCustomer: () => formFields.R_CUSTOMER,
                CustomerName: () => formFields.customerName,
                SublotCode: () => formFields.subLotCode,
                Description1: () => formFields.subLotDescription1,
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };

    const searchData = (formFields) => {
        const resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <SubLotSearchForm pageTitle={pageTitle} searchData={searchData} />
                        <SubLotSearchFormResult data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMLotDetailsWithCustomer);
